import React from 'react';
import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const MONO = "'IBM Plex Mono', monospace";

export default function Logo({ size = 30, to = '/', sx = {} }) {
  const fontSize = Math.round(size * 0.5);
  const wordSize = Math.round(size * 0.5);

  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '11px',
        textDecoration: 'none',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: size,
          height: size,
          border: '1.5px solid #2dd4bf',
          borderRadius: `${Math.round(size * 0.23)}px`,
          color: '#2dd4bf',
          fontFamily: MONO,
          fontWeight: 600,
          fontSize: fontSize,
          flexShrink: 0,
        }}
      >
        P
      </Box>
      <Box
        sx={{
          fontFamily: MONO,
          fontWeight: 600,
          letterSpacing: '.34em',
          fontSize: wordSize,
          color: '#f4f8ff',
        }}
      >
        PANDID
      </Box>
    </Box>
  );
}
